export enum WALLET_STATUS {
    ACTIVE = "ACTIVE",
    SUSPENDED = "SUSPENDED",
    INACTIVE = "INACTIVE",
}

export type WalletTransactionType = 'CREDIT' | 'DEBIT' | 'HOLD' | 'RELEASE';

export type CurrencyCode = "NGN" | "GHS" | "USD" | "EUR" | "GBP" | "CAD" ;

export interface BankDetails {
  accountName: string;
  accountNumber: string;
  bankCode: string;
  bankName: string;
  accountRef: string;
}

export interface Wallet {
  id: string;
  currency: CurrencyCode;
  name: string;
  symbol: string;
  flag: string;
  balance: number;
  heldBalance: number;
  incomingBalance: number;
  exchangeFeeBalance: number;
  status: WALLET_STATUS;
  hasBankAccount: boolean;
  bankDetails?: BankDetails;
}

export interface Transaction {
  id: string;
  amount: number;
  type: "CREDIT" | "DEBIT" | "HOLD" | "RELEASE";
  status: "SUCCESSFUL" | "PENDING" | "FAILED" | "UNKNOWN";
  purpose: string;
  narration?: string;
  createdAt: string;
  reference: string;
  symbol: string;
  currency: string;
  metadata?: any;
  paymentMethod: string;
 fee: number;
 paymentGatewayReference: string;
 walletId?: string;
}